import './App.css';
import { NaviBar } from './NaviBar';

function App() {
  return (
    <div className="App">
      <NaviBar></NaviBar>
    </div>
  );
}

export default App;
